import apiClient from '../client';
import { PayRule } from './payroll.service';

// One member of the company, all of it: who they are, their membership
// here, how they are paid (AO/CA only) and how they were hired. Read by
// the person page; written through the same PUT the Users list uses.

export interface PersonRecord {
  accountId: string;
  user: {
    userId: string; firstName: string; lastName: string; name: string; email: string; phone: string; profilePhoto: string;
  };
  account: {
    role: string;
    status: string;
    alsoPlatformAdmin: boolean;
    serviceAreaId: number | string | null;
    serviceArea: { id: number; csa: string; stationName: string } | null;
    employeeId: string;
    managerId: string | null;
    managerName: string;
    address: string;
    notes: string;
    licenseExpiryDate: string | null;
    dotCardExpiryDate: string | null;
    mecExpirationDate: string | null;
    invitationSentAt: string | null;
    invitationAcceptedAt: string | null;
    lastAccessedAt: string | null;
    createdAt: string | null;
  };
  /** Null when the caller may not see pay. */
  pay: {
    profileId: string | null; fedexId: string; rules: PayRule[]; description: string; hasRules: boolean; notes: string;
  } | null;
  hiring: {
    candidateId: string;
    stage: string;
    outcome: string | null;
    hiredAt: string | null;
    createdAt: string | null;
    source: string;
    sourceDetail: string;
    offeredPayRate: number | null;
    targetStartDate: string | null;
    licenseNumber: string;
    licenseState: string;
    licenseExpiresAt: string | null;
    mecExpiresAt: string | null;
    uniformSizes: string;
    workAuthorized: boolean | null;
    usCitizen: boolean | null;
    fedexId: string;
  } | null;
}

export interface PersonDetails {
  serviceAreaId?: number | null;
  employeeId?: string;
  managerId?: string | null;
  address?: string;
  notes?: string;
  licenseExpiryDate?: string | null;
  dotCardExpiryDate?: string | null;
  mecExpirationDate?: string | null;
}

export interface ServiceAreaOption { serviceAreaId: number; csa: string; stationName: string }

export default class PersonService {
  static async record(accountId: string): Promise<PersonRecord> {
    return apiClient.get(`/api/user/${accountId}/record`) as any;
  }

  static async updateDetails(accountId: string, changes: PersonDetails): Promise<void> {
    await apiClient.put(`/api/user/${accountId}`, changes);
  }

  static async serviceAreas(): Promise<ServiceAreaOption[]> {
    const data: any = await apiClient.get('/api/data/service-areas');
    return Array.isArray(data) ? data : [];
  }
}
